import axios, { AxiosRequestConfig } from 'axios'
import { url } from 'src/provider/config/constant'

export const billingApiCaller = axios.create({
    baseURL:  url.BILLING_BASE_URL 
})

billingApiCaller.interceptors.request.use(
    async (config: AxiosRequestConfig<any>) => {
        const token = await localStorage.getItem('authToken')
        
        if(token) {
            config.headers!.Authorization = `Bearer ${token}`
        }
        return config;
    },

    (err) => {
        return Promise.reject(err)
    }
)
